/**
 * @author        yewon@zumper.com (Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 */

import ageTextFunction from '../../../../shared/utils/ageTextFunction'

type Ageable =
  | {
      readonly listedOn: number
    }
  | { readonly modifiedOn: number }

export function getAgeText(
  rentable: Ageable,
  mini: true
): (
  now: number
) => '' | `1${'d' | 'h' | 'm'}` | `${number}${'d' | 'h' | 'm'}` | '5d+' | '24h+' | '60m+'
export function getAgeText(
  rentable: Ageable,
  mini?: false
): (
  now: number
) =>
  | ''
  | `1 ${'Day' | 'Hour' | 'Minute'} Ago`
  | `${number} ${'Days' | 'Hours' | 'Minutes'} Ago`
  | '5+ Days Ago'
  | '24+ Hours Ago'
  | '60+ Minutes Ago'
export function getAgeText(
  rentable: Ageable,
  mini?: boolean
): (
  now: number
) =>
  | ''
  | `1${'d' | 'h' | 'm'}`
  | `${number}${'d' | 'h' | 'm'}`
  | '5d+'
  | '24h+'
  | '60m+'
  | `1 ${'Day' | 'Hour' | 'Minute'} Ago`
  | `${number} ${'Days' | 'Hours' | 'Minutes'} Ago`
  | '5+ Days Ago'
  | '24+ Hours Ago'
  | '60+ Minutes Ago'
export function getAgeText(rentable: Ageable, mini?: boolean) {
  /**
   * @param now in milliseconds (`state.app.now`)
   */
  return (now: number) => {
    let age = Math.max(
      0,
      (now -
        (('listedOn' in rentable ? rentable.listedOn : undefined) ||
          ('modifiedOn' in rentable ? rentable.modifiedOn : undefined) ||
          0) *
          1000) /
        86400000
    )
    if (age >= 1) {
      return ageTextFunction(
        ~~age,
        '',
        mini ? '1d' : '1 Day Ago',
        mini ? 'd' : ' Days Ago',
        mini ? '5d+' : '5+ Days Ago',
        5
      )
    }
    age *= 24
    if (age >= 1) {
      return ageTextFunction(
        ~~age,
        '',
        mini ? '1h' : '1 Hour Ago',
        mini ? 'h' : ' Hours Ago',
        mini ? '24h+' : '24+ Hours Ago',
        24
      )
    }
    age *= 60
    return ageTextFunction(
      ~~age,
      mini ? '1m' : '1 Minute Ago',
      mini ? '1m' : '1 Minute Ago',
      mini ? 'm' : ' Minutes Ago',
      mini ? '60m+' : '60+ Minutes Ago',
      60
    )
  }
}
